export default "__VITE_ASSET__b1a25503__"